import React from "react";
import { BarChart3, CheckCircle, Clock } from "lucide-react";
import "./CompanyTaskToolTip.css";

const CompanyTaskTooltip = ({ company, isVisible, position }) => {
    if (!isVisible || !company) return null;

    const {
        taskCount = 0,
        ongoingTaskCount = 0,
        completedTaskCount = 0
    } = company;

    const total = taskCount;
    const completionRate =
        total > 0 ? Math.round((completedTaskCount / total) * 100) : 0;

    const getTooltipPosition = () => {
        const tooltipWidth = 320; // match TaskTooltip
        const screenWidth = window.innerWidth;
        const margin = 10;

        let left = position.x - tooltipWidth / 2;
        let top = position.y + 10;

        if (left + tooltipWidth > screenWidth - margin) {
            left = screenWidth - tooltipWidth - margin;
        }
        if (left < margin) {
            left = margin;
        }

        const tooltipHeight = 300;
        if (top + tooltipHeight > window.innerHeight - margin) {
            top = position.y - tooltipHeight - 10;
        }

        return { left, top };
    };

    const tooltipPosition = getTooltipPosition();

    return (
        <div className="task-tooltip-overlay">
            <div
                className="task-hover-modal"
                style={{
                    left: tooltipPosition.left,
                    top: tooltipPosition.top,
                }}
            >
                <div className="modal-header">
                    <h4>
                        <BarChart3 size={20} className="header-icon" />
                        Task Overview
                    </h4>
                </div>

                <div className="modal-content">
                    <div className="period-label">
                        <span>All Tasks</span>
                    </div>

                    <div className="main-stats">
                        <div className="stat-card total">
                            <div className="stat-number">{total}</div>
                            <div className="stat-label">Total Tasks</div>
                        </div>
                        <div className="stat-card completion">
                            <div className="stat-number">{completionRate}%</div>
                            <div className="stat-label">Completion Rate</div>
                        </div>
                    </div>

                    <div className="task-breakdown">
                        <div className="breakdown-item current">
                            <div className="breakdown-left">
                                <div className="breakdown-icon-container">
                                    <Clock size={16} className="breakdown-icon" />
                                </div>
                                <div className="breakdown-info">
                                    <div className="breakdown-title">Ongoing</div>
                                    <div className="breakdown-subtitle">In Progress</div>
                                </div>
                            </div>
                            <div className="breakdown-count">{ongoingTaskCount}</div>
                        </div>

                        <div className="breakdown-item completed">
                            <div className="breakdown-left">
                                <div className="breakdown-icon-container">
                                    <CheckCircle size={16} className="breakdown-icon" />
                                </div>
                                <div className="breakdown-info">
                                    <div className="breakdown-title">Completed</div>
                                    <div className="breakdown-subtitle">Finished</div>
                                </div>
                            </div>
                            <div className="breakdown-count">{completedTaskCount}</div>
                        </div>
                    </div>
                </div>

                <div className="tooltip-arrow"></div>
            </div>
        </div>
    );
};

export default CompanyTaskTooltip;
